import { render, staticRenderFns } from "./HomeCallout.vue?vue&type=template&id=8d5eb800&scoped=true&"
import script from "./HomeCallout.vue?vue&type=script&lang=js&"
export * from "./HomeCallout.vue?vue&type=script&lang=js&"
import style0 from "./HomeCallout.vue?vue&type=style&index=0&id=8d5eb800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5eb800",
  null
  
)

export default component.exports